import { render, staticRenderFns } from "./HandwareProducts.vue?vue&type=template&id=348df6cd"
import script from "./HandwareProducts.vue?vue&type=script&lang=js"
export * from "./HandwareProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports